module.exports = __webpack_public_path__ + "img/commentRate_3.a90d456d.png";